import { clsx } from 'clsx';

import { DEFAULT_ICON_SIZE } from '../constants';
import type { SVGIconProps } from '../types';
import styles from './AIAgent.animated.module.css';

export function AIAgentAnimated({
    className,
    size = DEFAULT_ICON_SIZE,
    state = 'default',
}: SVGIconProps & { state: 'default' | 'loading' }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 16 16"
            width={size}
            height={size}
            className={clsx(styles.root, className)}
            overflow="visible"
        >
            <title>Docs Agent</title>

            {/* Sparkle */}
            <path
                d="M12.8916 1.06265C12.921 0.979101 13.0392 0.979127 13.0685 1.06267C13.239 1.5478 13.3439 1.84646 13.516 2.1032C13.6683 2.33042 13.8578 2.53033 14.0766 2.6945C14.3239 2.88 14.6165 3.00068 15.0919 3.19671C15.1761 3.23142 15.1761 3.3506 15.0919 3.38531C14.6165 3.58134 14.3239 3.70203 14.0766 3.88752C13.8578 4.05169 13.6683 4.2516 13.516 4.47882C13.3439 4.73556 13.239 5.03423 13.0685 5.51937C13.0392 5.60291 12.921 5.60292 12.8916 5.51938C12.7212 5.03423 12.6162 4.73557 12.4442 4.47882C12.2919 4.2516 12.1023 4.05169 11.8835 3.88752C11.6363 3.70202 11.3436 3.58134 10.8682 3.38531C10.7841 3.3506 10.7841 3.23141 10.8683 3.1967C11.3436 3.00067 11.6363 2.87999 11.8835 2.6945C12.1023 2.53033 12.2919 2.33042 12.4442 2.1032C12.6162 1.84646 12.7212 1.54779 12.8916 1.06265Z"
                stroke="currentColor"
                stroke-width="1.2"
                stroke-linejoin="round"
                className={state === 'loading' ? styles.animateSparkle : ''}
                style={{ transformOrigin: '80% 20%' }}
            />

            {/* Eyes */}
            <path
                d="M6.0625 6.01367C6.39387 6.01367 6.66211 6.28191 6.66211 6.61328V7.61328C6.66211 7.94465 6.39387 8.21289 6.0625 8.21289C5.73113 8.21289 5.46289 7.94465 5.46289 7.61328V6.61328C5.46289 6.28191 5.73113 6.01367 6.0625 6.01367ZM9.9375 6.01367C10.2689 6.01367 10.5371 6.28191 10.5371 6.61328V7.61328C10.5371 7.94465 10.2689 8.21289 9.9375 8.21289C9.60624 8.21276 9.33789 7.94457 9.33789 7.61328V6.61328C9.33789 6.28199 9.60624 6.0138 9.9375 6.01367Z"
                fill="currentColor"
                className={state === 'loading' ? styles.animateEyes : ''}
            />

            {/* Mouth */}
            <path
                d="M9.93762 10.1133C9.93762 11.0767 9.07012 11.0977 8 11.0977C6.92988 11.0977 6.06238 11.0767 6.06238 10.1133"
                stroke="currentColor"
                stroke-width="1.2"
                stroke-linecap="round"
                className={state === 'loading' ? styles.invisible : ''}
            />

            {/* Face outline — Default */}
            <path
                d="M13.2812 8.45703L13.2812 11.7695C13.2812 12.8741 12.3858 13.7695 11.2812 13.7695L4.71875 13.7695C3.61418 13.7695 2.71875 12.8741 2.71875 11.7695L2.71875 4.72363C2.71875 3.95507 3.34179 3.33203 4.11035 3.33203V3.33203L8.12646 3.33203"
                stroke="currentColor"
                stroke-width="1.2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />

            {/* Ears (Left + Right */}
            <path
                d="M2.31396 10.4885C0.84588 10.4885 0.813965 9.62102 0.813965 8.5509C0.813965 7.48078 0.84588 6.61328 2.31396 6.61328"
                stroke="currentColor"
                stroke-width="1.2"
                stroke-linecap="round"
            />
            <path
                d="M15.155 8.55066C15.155 9.62078 15.1231 10.4883 13.655 10.4883"
                stroke="currentColor"
                stroke-width="1.2"
                stroke-linecap="round"
            />
        </svg>
    );
}
